import '../../App.css';
import { Scroller, Section } from 'react-fully-scrolled';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';
// Import Swiperstyles
import 'swiper/css';
import 'swiper/css/navigation';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import AOS Animation
import Aos from 'aos';
import 'aos/dist/aos.css';

import { useSelector, useDispatch } from 'react-redux';

import {
  fetchVideos,
  videoPush,
  videosIsEmpty,
  videosStore,
} from '../store/reducers/videoSlice';
import {
  fetchRecommendationProperty,
  recommendationPropertiesStore,
  recommendationPropertyIsEmpty,
  recommendationPropertyPush,
} from '../store/reducers/recommendationPropertySlice';
import {
  articlePush,
  articlesIsEmpty,
  articlesStore,
  fetchArticles,
} from '../store/reducers/articleSlice';

// import Swiper core and required modules
import SwiperCore, { Navigation } from 'swiper';
// Import Mantine
import { Container, createStyles, Center, Button, Title } from '@mantine/core';
import { Carousel } from '@mantine/carousel';
// Import Components
import JumboTron2 from '../components/jumbotron-2/jumbotron2-component';
import CarouselCompo2 from '../components/carousel2/carousel2-component';
import PromotionCompo from '../components/promotion/promotion-component';
import VideoCompo from '../components/content/video-component';
import CardArticleCompo from '../components/content/cardarticle-component';
import HomePageJumbotron from '../components/homepageJumbotron/homepage-jumbotron';
import { FooterCompo } from '../components';
import PartnersCompo from '../components/partners/partners-component';
import PartnersMobileCompo from '../components/partners/partnersmobile-component';
import AgenFeature from '../components/carouselAgen/agenfeature-component';

// install Swiper modules
SwiperCore.use([Navigation]);

const useStyle = createStyles((theme) => ({
  rowDekstop: {
    // height: 600,
  },
  rowMobile: {
    height: 600,
    '@media (min-width: 992px)': {
      height: 700,
    },
  },
  video: {
    position: 'absolute',
    zIndex: '-1',
  },
  containerCarousel2: {
    paddingLeft: 0,
    paddingRight: 0,
    maxWidth: '100%',
    marginLeft: 0,
    marginRight: 0,
    '@media (max-width: 600px)': {
      paddingLeft: 0,
    },
  },
  pembatas: {
    width: '100%',
    height: 400,
    backgroundColor: 'transparent',
    '@media (max-width: 600px)': {
      height: 0,
    },
    '@media (min-width: 600px)': {
      height: 20,
    },
    '@media (min-width: 768px)': {
      height: 140,
    },
    '@media (min-width: 992px)': {
      height: 300,
    },
    '@media (min-width: 1200px)': {
      height: 150,
    },
    '@media (min-width: 1400px)': {
      height: 0,
    },
    '@media (min-width: 1600px)': {
      height: 0,
    },
  },
  container: {
    width: '100%',
    '@media (max-width: 600px)': {
      marginLeft: 30,
    },
    '@media (min-width: 600px)': {
      marginLeft: 50,
    },
    '@media (min-width: 768px)': {
      marginLeft: 100,
    },
    '@media (min-width: 1200px)': {
      marginLeft: '260px!important',
    },
    '@media (min-width: 992px)': {
      marginLeft: 150,
    },
  },
  control: {
    backgroundColor: '#F2EEC8',
    color: '#F56600',
    borderColor: '#F2EEC8',
    opacity: 1,
  },
  containerVideo: {
    '@media (max-width: 600px)': {
      display: 'none',
    },
    '@media (min-width: 600px)': {
      display: 'none',
    },
    '@media (min-width: 768px)': {
      display: 'none',
    },
    '@media (min-width: 992px)': {
      display: 'block',
    },
  },
  rowVideo: {
    gap: '4rem',
    '@media (max-height: 500px)': {
      gap: '1rem',
    },
    '@media (min-height: 500px)': {
      gap: '1rem',
    },
  },
  buttonSelengkapnyaVideo: {
    '@media (min-width: 1200px) and (max-height: 500px)': {
      position: 'absolute',
      right: 150,
      bottom: 60,
    },
    '@media (min-width: 1400px) and (max-height: 500px)': {
      position: 'absolute',
      right: 260,
      bottom: 60,
    },
    '@media (min-width: 1600px) and (max-height: 500px)': {
      position: 'absolute',
      right: 370,
      bottom: 60,
    },
  },
  slide: {},
  containerSlide: {
    '@media (max-width: 600px)': {
      width: '240px!important',
    },
  },
  head1: {
    '@media (min-width: 1200px)': {
      paddingTop: '10%',
    },
    '@media (max-height: 500px)': {
      paddingTop: '1%!important',
    },
    '@media (min-height: 500px) and (max-height: 600px)': {
      paddingTop: '2%',
      transition: '0.5s',
    },
    '@media (min-height: 600px) and (max-height: 800px)': {
      paddingTop: '5%!important',
    },
  },
  head1H1: {
    '@media (max-height: 500px)': {
      fontSize: '50px!important',
    },
    '@media (min-height: 500px) and (max-height: 600px)': {
      fontSize: '50px!important',
    },
    '@media (min-height: 600px) and (max-height: 750px)': {
      fontSize: '60px!important',
    },
    '@media (min-height: 750px) and (max-height: 800px)': {
      fontSize: '80px!important',
    },
    // '@media (max-height: 700px)': {
    //   fontSize: '70px!important',
    // },
  },
  titlePartner: {
    fontFamily: 'Poppins, sans-serif',
    color: '#F56600',
    fontSize: 48,
    fontWeight: 700,
    marginTop: '5%',
    marginBottom: 10,
    textAlign: 'center',
    '@media (max-width: 600px)': {
      fontSize: 30,
      marginTop: 32,
    },
    '@media (max-width: 600px) and (max-height: 500px)': {
      fontSize: 35,
    },
    '@media (min-width: 600px)': {
      fontSize: 40,
    },
    '@media (min-height: 800px)': {
      marginTop: 15,
    },
    '@media (min-width: 1200px) and (max-height: 500px)': {
      marginTop: '1%',
    },
    '@media (min-width: 1200px) and (min-height: 500px)': {
      marginTop: '1%',
    },
    '@media (min-width: 1200px) and (min-height: 700px)': {
      marginTop: 12,
    },
    '@media (min-width: 1600px) and (min-height: 900px)': {
      paddingTop: 65,
    },
    '@media (min-width: 1800px) and (min-height: 900px)': {
      marginBottom: 90,
      paddingTop: 30,
      marginTop: 0,
    },
  },
  wrapperFooter: {},
  containerFooter: {
    marginTop: 0,
  },
  containerButton: {
    position: 'absolute',
    bottom: 15,
    left: 30,
    '@media (max-width: 600px)': {
      bottom: -50,
    },
  },
  articleButton: {
    padding: 20,
    fontSize: 15,
    fontWeight: 700,
    maxWidth: '200px',
    maxHeight: '70px',
    boxShadow:
      'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;',
    '@media (max-width: 600px) and (max-height: 500px)': {
      padding: 10,
    },
    '@media (max-width: 600px) and (min-height: 500px)': {
      padding: 12,
    },
    '@media (min-width: 600px) and (max-height: 500px)': {
      padding: 12,
      fontSize: 15,
    },
    '@media (min-width: 600px) and (min-height: 500px)': {
      padding: 12,
      fontSize: 15,
    },
    '@media (min-width: 600px) and (min-height: 600px)': {
      padding: 12,
      fontSize: 15,
    },
    '@media (min-width: 600px) and (min-height: 700px)': {
      padding: 12,
      fontSize: 15,
    },
  },
  containerArticle: {
    '@media (max-width: 600px)': {
      height: 550,
    },
  },
}));

const HomePage = () => {
  const { classes } = useStyle();
  const [fetching, setFetching] = useState(false);

  const videos = useSelector(videosStore);
  const articles = useSelector(articlesStore);
  const recommendationProperties = useSelector(recommendationPropertiesStore);

  const recommendationPropertyEmpty = useSelector(
    recommendationPropertyIsEmpty
  );
  const VideosEmpty = useSelector(videosIsEmpty);
  const articlesEmpty = useSelector(articlesIsEmpty);

  const dispatch = useDispatch();

  useEffect(() => {
    Aos.init({
      duration: 300,
      easing: 'ease-in-sine',
      offset: 200,
      delay: 100,
    });

    if (!fetching) {
      (async function fetch() {
        if (recommendationPropertyEmpty)
          dispatch(await fetchRecommendationProperty());
        if (articlesEmpty) dispatch(await fetchArticles());
        if (VideosEmpty) dispatch(await fetchVideos());
      })().then((value) => setFetching(true));
    }
  }, [
    fetching,
    dispatch,
    recommendationPropertyEmpty,
    VideosEmpty,
    articlesEmpty,
  ]);
  return (
    <>
      {/* /---------------------------------------------/

      DEKSTOP VIEW FOCUS

    /---------------------------------------------/ */}
      <div className="dekstopView">
        <Scroller
          onBeforeScroll={(from, to) => {}}
          onAfterScroll={(page) => {}}
        >
          <Section className="pagesscroll1">
            <HomePageJumbotron />
            <div className={classes.pembatas}></div>
          </Section>
          <Section className="pagesscroll2">
            <div className="container-fluid">
              <div className={`row ${classes.rowDekstop}`}>
                <div className="col-12 pertama">
                  <div className="img-wrapper">
                    <img
                      src={require('../assets/images/pattern1.png')}
                      alt=""
                      className="pattern1"
                    />
                  </div>
                  <div className={`head-1 ${classes.head1}`}>
                    <h1 className={classes.head1H1}>
                      Cari rumah
                      <br />
                      idamanmu di sini
                    </h1>
                  </div>
                </div>
                <div className="col-12 rekomendasiRumah mb-5">
                  <Container className={classes.containerCarousel2}>
                    <Carousel
                      controlsOffset="10%"
                      controlSize={40}
                      slideSize={350}
                      slideGap={30}
                      align="start"
                      classNames={{
                        container: classes.container,
                        control: classes.control,
                      }}
                      styles={{
                        control: {
                          '&[data-inactive]': {
                            opacity: 0.5,
                            cursor: 'default',
                          },
                        },
                      }}
                    >
                      {recommendationProperties?.map((item, key) => {
                        return (
                          <Link to={`/properti?id=${item.id}`} key={key}>
                            <CarouselCompo2
                              image={item.images[0]}
                              title={item.name}
                              address={`${item.address.street}, ${
                                item.address.lower_city[0].toUpperCase() +
                                item.address.lower_city.substring(1)
                              }`}
                            />
                          </Link>
                        );
                      })}
                    </Carousel>
                  </Container>
                </div>
                <div className="pattern2">
                  <img
                    src={require('../assets/images/pattern2.png')}
                    alt=""
                    className="pattern2"
                  />
                </div>
              </div>
            </div>
          </Section>
          <Section className="pagesscroll3">
            <div className="row">
              <div className="col-12">
                <div className="promoCarousel">
                  <PromotionCompo />
                </div>
              </div>
            </div>
          </Section>
          <Section className="pagesscroll4">
            <div className="head3">
              <h1 className="text-center tajuk">
                Dapatkan informasi yang
                <br />
                kamu butuhkan di sini
              </h1>
            </div>
            <div className="head3-vidio">
              <img
                className="pattern4"
                src={require('../assets/images/Frame 923.png')}
                alt=""
              />
              <div className={`container ${classes.containerVideo}`}>
                <div className="row">
                  <div className="col col-lg-12">
                    <div
                      className={`row justify-content-center ${classes.rowVideo}`}
                    >
                      {videos?.slice(0, 3).map((item, key) => {
                        return (
                          item && (
                            <VideoCompo
                              key={key}
                              myId={item.id}
                              video={item.cover_url}
                              title={item.title}
                              desc={item.caption}
                              likes={item.likes}
                              item={item}
                            />
                          )
                        );
                      })}
                    </div>
                  </div>
                </div>
                <Center className={classes.buttonSelengkapnyaVideo}>
                  <Link to="/konten-video">
                    <Button
                      size="md"
                      radius={50}
                      color="teal.9"
                      className="text-center"
                      mt={40}
                      mb={40}
                    >
                      Selengkapnya
                    </Button>
                  </Link>
                </Center>
              </div>
              {/* <img
                className="pattern5"
                src={require('../assets/images/Frame 916.png')}
                alt=""
              /> */}
            </div>
          </Section>
          <Section className="pagesscroll5">
            <div className="row">
              <div className="col-12">
                <div className="head2">
                  <h5 className="title">
                    Jadikan dirimu sebagai agen
                    <br />
                    profesional bersama kami
                  </h5>

                  <AgenFeature />
                  <a
                    className="btnAgenContainer"
                    href="https://api.whatsapp.com/send/?phone=6281335258080&text=Saya+ingin+mendaftar+menjadi+Agen%2C+bagaimana+cara+untuk+menjadi+agen+di+Sepakat+Properti&type=phone_number&app_absent=0"
                  >
                    <button className="btn btn-success rounded-pill">
                      Gabung Sepakat
                    </button>
                  </a>

                  {/* <img
                    className="pattern3"
                    src={require('../assets/images/Frame 860.png')}
                    alt=""
                  /> */}
                </div>
              </div>
            </div>
          </Section>
          <Section className="pagesscroll6">
            <JumboTron2 />
          </Section>
          <Section className="pagesscroll7">
            <Title className={classes.titlePartner}>
              Kerjasama dan Kemitraan
            </Title>
            <div className="dekstopPartners">
              <PartnersCompo />
            </div>
            <div className="mobilePartners">
              <PartnersMobileCompo />
            </div>
            <div className="footerContainer">
              <FooterCompo />
            </div>
          </Section>
        </Scroller>
      </div>
      {/* 
      /---------------------------------------------/

        MOBILE VIEW FOCUS
      
      /---------------------------------------------/
       */}
      <div className="mobileView">
        <Section className="pagesscroll1">
          <HomePageJumbotron />
          {/* <div className={classes.pembatas}></div> */}
        </Section>
        <Section className="pagesscroll2">
          <div className="container-fluid">
            <div className={`row ${classes.rowMobile}`}>
              <div className="col-12 pertama">
                <div className="img-wrapper">
                  <img
                    src={require('../assets/images/pattern1.png')}
                    alt=""
                    className="pattern1"
                  />
                </div>
                <div className="head-1">
                  <h1>
                    Cari rumah
                    <br />
                    idamanmu di sini
                  </h1>
                </div>
              </div>
              <div className="col-12 rekomendasiRumah mb-5">
                <Container className={classes.containerCarousel2}>
                  <Carousel
                    controlsOffset="10%"
                    controlSize={30}
                    slideSize={350}
                    slideGap={30}
                    align="start"
                    classNames={{
                      container: classes.container,
                      control: classes.control,
                    }}
                    styles={{
                      control: {
                        opacity: 0.1,
                        '&[data-inactive]': {
                          opacity: 0,
                          cursor: 'default',
                        },
                      },
                    }}
                  >
                    {recommendationProperties?.map((item, key) => {
                      return (
                        <Link to={`/properti?id=${item.id}`} key={key}>
                          <CarouselCompo2
                            image={item.images[0]}
                            title={item.name}
                            address={`${item.address.street}, ${
                              item.address.lower_city[0].toUpperCase() +
                              item.address.lower_city.substring(1)
                            }`}
                          />
                        </Link>
                      );
                    })}
                  </Carousel>
                </Container>
              </div>
              <div className="pattern2">
                <img
                  src={require('../assets/images/pattern2.png')}
                  alt=""
                  className="pattern2"
                />
              </div>
            </div>
          </div>
        </Section>
        <Section className="pagesscroll3">
          <div className="row">
            <div className="col-12">
              <div className="promoCarousel">
                <PromotionCompo />
              </div>
            </div>
          </div>
        </Section>
        <Section className="pagesscroll4">
          <div className="head3">
            <h1 className="text-center tajuk">
              Dapatkan informasi yang <br />
              kamu butuhkan di sini
            </h1>
          </div>
          <div className="head3-article">
            <img
              className="pattern4"
              src={require('../assets/images/Frame 923.png')}
              alt=""
            />
            <div className={`container-fluid ${classes.containerArticle}`}>
              <Carousel
                withControls={true}
                controlSize={40}
                slideSize={350}
                slideGap={0}
                align="start"
                pl={30}
                classNames={{
                  root: classes.root,
                  slide: classes.slide,
                  container: classes.containerSlide,
                  control: classes.control,
                }}
                sx={{
                  overflow: 'visible',
                  '@media (max-width: 600px)': {
                    paddingLeft: 0,
                  },
                }}
                styles={{
                  control: {
                    opacity: '0.2',
                    '&[data-inactive]': {
                      opacity: 0,
                      cursor: 'default',
                    },
                  },
                }}
              >
                {articles?.slice(0, 3).map((item, key) => {
                  return (
                    item && (
                      <Carousel.Slide
                        key={key}
                        sx={{
                          '@media (max-width: 600px)': {
                            marginRight: 0,
                            paddingLeft: 30,
                          },
                          '@media (min-width: 600px)': {
                            marginRight: 30,
                          },
                        }}
                        mr={30}
                      >
                        <CardArticleCompo
                          image={item.cover_url}
                          title={item.title}
                          article={item.caption}
                          likes={item.likes}
                        />
                      </Carousel.Slide>
                    )
                  );
                })}
              </Carousel>
              <Link to="/article-content" className={classes.containerButton}>
                <button
                  className={`btn btn-success rounded-5 mt-3 ms-2 ${classes.articleButton}`}
                >
                  Artikel Lainnya
                </button>
              </Link>
            </div>
            <img
              className="pattern5"
              src={require('../assets/images/Frame 916.png')}
              alt=""
            />
          </div>
        </Section>
        <Section className="pagesscroll5">
          <div>
            <div className="col-12">
              <div className="head2">
                <h5 className="title">
                  Jadikan dirimu sebagai agen
                  <br />
                  profesional bersama kami
                </h5>

                <AgenFeature />
                <a
                  className="btnAgenContainer"
                  href="https://api.whatsapp.com/send/?phone=6281335258080&text=Saya+ingin+mendaftar+menjadi+Agen%2C+bagaimana+cara+untuk+menjadi+agen+di+Sepakat+Properti&type=phone_number&app_absent=0"
                >
                  <button className="btn btn-success rounded-pill">
                    Gabung Sepakat
                  </button>
                </a>
              </div>
            </div>
          </div>
        </Section>
        <Section className="pagesscroll6">
          <JumboTron2 />
        </Section>
        <Section className="pagesscroll7">
          <Title className={classes.titlePartner}>
            Kerjasama dan Kemitraan
          </Title>
          <div className="dekstopPartners">
            <PartnersCompo />
          </div>
          <div className="mobilePartners">
            <PartnersMobileCompo />
          </div>
          <div className="footerDekstop">
            <div className="footerWrapper">
              <div className="footerContainer">
                <FooterCompo />
              </div>
            </div>
          </div>
        </Section>
        <div className="footerMobile">
          <FooterCompo />
        </div>
      </div>
    </>
  );
};

export default HomePage;
